import axios from 'axios';

import lstModules from 'common/json/lstModules.json';

const httpURL = lstModules['main'].url + ':' + lstModules['main'].port;
const httpURLAcdYr = lstModules['academicYear'].url + ':' + lstModules['academicYear'].port;

var tokenid = localStorage.getItem("tokenid");

export const getSubstitutionDutiesSvc = (fromDt, toDt, callback) => {
    // console.log("getSubstitutionDutiesSvc called");
    const formData = new FormData();
    formData.append("fromDt", fromDt);
    formData.append("toDt", toDt);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/subs_report/subs_duties',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
        data: formData
    }).then((response) => {
        // console.log('response in getSubstitutionDutiesSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchSubsDuty = response.data.lstTchSubsDuty;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
export const getYearlySubstitutionDutiesSvc = (acdYrId, callback) => {
    console.log("getYearlySubstitutionDutiesSvc called");
    const formData = new FormData();
    formData.append("acdYrId", acdYrId);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/subs_report/summary/year/subs_duties',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
        data: formData
    }).then((response) => {
        console.log('response in getYearlySubstitutionDutiesSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchSubsYearlySummary = response.data.lstTchSubsYearlySummary;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}
export const getMonthlySubstitutionDutiesSvc = (yyyyMm, callback) => {
    console.log("getMonthlySubstitutionDutiesSvc called");
    const formData = new FormData();
    formData.append("forYYYYMM", yyyyMm);
    var obj = { status: "Success", message: "" }
    axios({
        url: httpURL + '/sms/tt/v2/subs_report/summary/month/subs_duties',
        method: "POST",
        headers: { 'tokenid': tokenid },
        withCredentials: true,
        data: formData
    }).then((response) => {
        console.log('response in getMonthlySubstitutionDutiesSvc', response);
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        if (response.data.SvcStatus === "Success") {
            obj.lstTchSubsMonthlySummary = response.data.lstTchSubsMonthlySummary;
        }
        callback(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        callback(obj);
    });
}


export const getAcademicYearListSvc = (cbAcademicYearList) => {
    const obj = { status: "", message: "" };
    axios({
        url: httpURLAcdYr + '/sms/acdyr/list',
        method: "POST",
        headers: { 'tokenid': tokenid },
        params: { 'screenId': 0 },
        withCredentials: true,
    }).then((response) => {
        obj.status = response.data.SvcStatus;
        obj.message = response.data.SvcMsg;
        obj.lstAcademicYear = response.data.lstAcademicYear;
        cbAcademicYearList(obj);
    }).catch((error) => {
        obj.status = "Exception";
        obj.message = error;
        cbAcademicYearList(obj);
    })
}
